import { t as __t } from "i18next";
import React, { useState, useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import CopyrightFooter from "../../../components/footer/employers/CopyrightFooter";
import DashboardHeader from "../../../components/header/DashboardHeader";
import { dateToString, encodeBase64, FormatCurrencys, displayUrl, convertStringToJson } from "../../../utils/commonUtil"
import DashboardEmployerSidebar from "../../../components/header/DashboardSidebar";
import MobileMenu from "../../../components/header/MobileMenu";
import "../../../components/i18n/lang";
import { useTranslation } from "react-i18next";
import moment from "moment";
import Swal from "sweetalert2";
import { callExportAgent } from "../../../api/export";
import { callApproveCancelContract, callGetCancelContract, } from "../../../api/contract/service";
import SmartTable from "../../../components/common/table-component";
import PermissionWrapper from "../../../components/common/PermissionWrapper";
import SwalAlert from "../../../components/common/alert";

import { APPROVE, CANCEL } from "../../../utils/commonType"
import { Modal } from "bootstrap";
import { render } from "@testing-library/react";
import { approvedOrRejectCancelAgent, searchReqCancelAgent } from "../../../api/callcenters/service";
import itemsApporve from "../../../data/approvedStatus";
import itemsReq from "../../../data/statusReq";
import { DocumentPreviewUI } from "../../../components/document-preview";
const Index = () => {
	const userInfo = useSelector((state) => state.dataLogin);
	const { pathname } = useLocation();
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const { t } = useTranslation();
	const [request, setRequest] = useState({ page: 1, maxResult: 10, keyword: '', status: '' });
	const [requestCancel, setRequestCancel] = useState({ id: '', status: 0, reason: '', modifiedCode: '', modifiedName: '' });
	const [contract, setContract] = useState({ totalPages: 0, totalRecords: 0, result: [] });
	const [totalPages, setTotalPages] = useState(1);
	const [totalRecord, setTotalRecord] = useState(0);
	const location = useLocation();
	const fileInputRef = useRef();

	useEffect(() => {
		loadData();
	}, [location.state]);
	const columns = [
		{
			label: 'agentCancelAgentCode', key: 'agentCode', style: { minWidth: '220px' }, render: (val) => (
				val ? val : '-')
		},
		{ label: 'agentCancelAgentName', style: { minWidth: '100px' }, key: 'fullName', render: (val) => (val ? val : '-') },
		{ label: 'agentCancelRequestReason', style: { minWidth: '220px' }, key: 'requestReason' },
		{
			label: 'agentCancelRejectReason', style: { minWidth: '200px' }, key: 'reason'
		},
		{
			label: 'agentCancelDocument', key: 'documentPath', render: (val) => {
				try {
					return val && <DocumentPreviewUI documents={val} variant="cell" />
				} catch (error) {
					return ''
				}
			}
		},
		{
			label: 'agentCancelCreateDate', key: 'createDate', render: (val) => (
				val ? dateToString(val, 'DD/MM/YYYY') : '-'
			)
		}, {
			label: 'agentCancelModifiedDate', key: 'modifiedDate', render: (val) => (
				val ? dateToString(val, 'DD/MM/YYYY') : '-'
			)
		}
		, {
			label: 'agentCancelStatus', key: 'status', render: (val) => (
				val ? <span className={"badge " + (val === 2 ? "bg-warning" : val === 3 ? "bg-danger" : "bg-success")}>{t('statusVehicleCancel.' + val)}</span> : '-'
			)
		},
	];

	const loadData = async (e) => {
		let data = { ...request };
		if (e) {
			data = e
		}
		const rsp = await dispatch(searchReqCancelAgent(data));
		if (rsp?.payload?.responseCode === "00000") {
			console.log(rsp.payload.data)
			setContract(rsp.payload.data)
		}

	}

	const handleChange = (e) => {
		setRequest((prev) => ({ ...prev, keyword: e.target.value }));
	};
	const handleChangeCancel = (e) => {
		const { name, value } = e.target;
		setRequestCancel((prev) => ({
			...prev,
			[name]: value
		})
		);
	};
	const onSearch = async (e) => {
		e.preventDefault()
		loadData()
	}

	const handleApprove = (item) => {
		SwalAlert.confirm(t("titleApprove"), t("confirmApprove"), async () => {
			try {
				const rsp = await dispatch(approvedOrRejectCancelAgent({
					id: item.id,
					status: 1,
					agentId: item.agentId,
					type: item.type,
					reason: "approve Vehicle contract",
					modifiedCode: userInfo?.data?.user?.userId,
					modifiedName: `${userInfo?.data?.user?.firstName} ${userInfo?.data?.user?.lastName || ''}`
				}));
				if (rsp?.payload?.responseCode === "00000") {
					SwalAlert.successMSG(t('success.approved'))
					loadData()
				}
			} catch (error) {
				SwalAlert.error(__t("uiText.text023"), __t("uiText.text024"),);
			}
		})
	}
	const selectStatus = (e) => {
		setRequest((prev) => ({
			...prev,
			status: e.target.value,
		}));
	}

	const handleSave = async (e) => {
		e.preventDefault()
		SwalAlert.confirm(t("nameSave"), t("confirmSave"), async () => {
			try {
				const rsp = await dispatch(approvedOrRejectCancelAgent(requestCancel));
				if (rsp?.payload?.responseCode === "00000") {
					SwalAlert.successMSG(t('success.reject'))
					const myModal = document.getElementById("rejectPopupModal");
					const modal = Modal.getInstance(myModal);
					modal.hide();
					loadData()
				}
			} catch (error) {
				SwalAlert.error(__t("uiText.text023"), __t("uiText.text024"),);
			}
		});
	};

	return (
		<div className="page-wrapper dashboard">
			<span className="header-span"></span>
			<DashboardHeader />
			<MobileMenu />
			<DashboardEmployerSidebar />
			<section className="user-dashboard">
				<div className="dashboard-outer">
					<div className="upper-title-box">
						<h4>{t("menu.approved.cancelAgent")}</h4>
					</div>

					<div className="row">
						<div className="col-12">
							<div className="ls-widget">
								<div className="tabs-box">
									<div className="widget-content p-4">
										<div className="default-form">
											<div className="row">
												<div className="col-md-3">
													<div className="form-group">
														<label>{t('search.keyword')}</label>
														<input
															type="text"
															name="keyword"
															className="form-control-uld"
															placeholder={t('search.keyword') + "..."}
															onChange={handleChange}
															value={request.keyword}
															autoComplete="off"
															required />
													</div>
												</div>
												<div className="col-md-3 form-group">
													<label>{t('status.text')}</label>
													<select className="chosen-single form-select"
														onChange={selectStatus}
														value={request.status}
													>
														<option key={0} value={""}>{t("selectedAll")}</option>
														{
															itemsReq.map((item) => (
																<option key={item.id} value={item.key}>{t(item.name)}</option>
															))
														}
													</select>
												</div>
												<div className="col-auto auto-button">
													<label style={{ marginTop: 6 }}>&nbsp;</label>
													<button className="theme-btn btn-style-one w-100" onClick={onSearch}>
														<i className="fas fa-search"></i>&nbsp;{t("button.search")}
													</button>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div className="row">
						<div className="col-12">
							<div className="ls-widget">
								<div className="tabs-box">
									<div className="widget-content p-4">
										<SmartTable columns={columns} data={contract} keyword={request.keyword} onLazyLoad={loadData}
											actions={(item) => (
												<div style={{ minWidth: 60 }}>
													<PermissionWrapper permission={APPROVE}>
														{item.status == 2 && <button className="btn btn-success btn-sm" onClick={() => handleApprove(item)}>
															<i className="fas fa-check"></i>
														</button>}
													</PermissionWrapper>
													&nbsp;

													<PermissionWrapper permission={CANCEL}>
														{item.status == 2 && <button className="btn btn-primary btn-sm" data-bs-toggle="modal" data-bs-target="#rejectPopupModal" onClick={() => setRequestCancel((prev) => ({
															id: item.id,
															status: 3,
															type: item.type,
															modifiedCode: userInfo?.data?.user?.userId,
															modifiedName: `${userInfo?.data?.user?.firstName} ${userInfo?.data?.user?.lastName || ''}`
														}))}>
															<i className="fas fa-times-circle"></i>
														</button>
														}
													</PermissionWrapper>
												</div>
											)}
										/>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			<CopyrightFooter />
			<div className="modal fade" id="rejectPopupModal">
				<div className="modal-dialog modal-lg modal-dialog-centered login-modal modal-dialog-scrollable">
					<div className="modal-content">
						<button
							type="button"
							className="closed-modal"
							data-bs-dismiss="modal"
						></button>
						{/* End close modal btn */}

						<div className="modal-body">
							{/* <!-- Login modal --> */}
							<div id="login-modal">
								{/* <!-- Login Form --> */}
								<div className="login-form default-form">
									<div className="form-inner">
										<h3>{t("agent.cancel.rejectCancel")}</h3>
										<form onSubmit={handleSave}>
											<div className="default-form">
												<div className="row">
													<div className="col-md-12 form-group">
														<label> {t('contracts.vehicle.rejectDescription')}</label>
														<textarea
															id="reason"
															name="reason"
															rows="5"
															cols="40"
															value={requestCancel.reason}
															onChange={handleChangeCancel}
															placeholder={t('contracts.life.clame.description')}
														/>
													</div>
													<div className="col-12 d-flex justify-content-center">
														<div className="m-3">
															<button className="theme-btn btn-style-one w-100" type="submit">
																<i className="fas fa-add"></i>&nbsp;{t("button.save")}
															</button>
														</div>
													</div>
												</div>
											</div>
										</form>
									</div>
								</div>
								{/* <!--End Login Form --> */}
							</div>
							{/* <!-- End Login Module --> */}
						</div>
						{/* En modal-body */}
					</div>
					{/* End modal-content */}
				</div>
			</div>
		</div >
	);
};

export default Index;
